module.exports = __webpack_public_path__ + "static/img/ppt.85330b58.png";